import breakPoints from 'helpers/Styles';

const ImageWithTexts = ({ block, primaryFontColor, secondaryFontColor }) => {
  if (!block) return '';
  const { primary } = block;
  const title = primary?.title1 ? primary.title1 : null;
  const titleColour = primary?.title1_colour
    ? primary.title1_colour
    : primaryFontColor;
  const subtitle = primary.subtitle ? primary.subtitle : null;
  const subtitleColour = primary?.subtitle_colour
    ? primary.subtitle_colour
    : secondaryFontColor;
  const imageUrl = primary.image ? primary.image.url : null;
  const imageMobile = primary.image_mobile ? primary.image_mobile.url : null;
  return (
    <>
      <div className='image_with_title wrapper'>
        {title && (
          <div className='title'>
            <p>{title}</p>
            <h1>{subtitle}</h1>
          </div>
        )}
        <img
          draggable='false'
          src={imageUrl}
          alt='image_desktop'
          className='image_desktop'
        />
        <img
          draggable='false'
          src={imageMobile}
          alt='image_mobile'
          className='image_mobile'
        />
      </div>
      <style jsx>
        {`
          .image_with_title {
            background: inherit;
          }
          img {
            width: 100%;
            margin: 0;
            padding: 0;
          }
          .title p {
            color: ${titleColour};
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 24px;
            text-align: center;
            margin: 0;
            margin-bottom: 20px;
          }
          .title h1 {
            color: ${subtitleColour};
            font-family: 'big_noodle_titling';
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
            text-align: center;
            margin: 0;
            margin-bottom: 40px;
            padding: 10px;
          }
          .image_mobile {
            display: none;
          }
          @media (max-width: ${breakPoints.small}) {
            .image_with_title {
              padding: 0;
            }
            .title h1 {
              font-size: 26px;
            }
            .image_desktop {
              display: none;
            }
            .image_mobile {
              display: block;
            }
          }
        `}
      </style>
    </>
  );
};

export default ImageWithTexts;
